if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {    
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) =>{ 
          return response.json();
        })
        .then((response) => {
          Shopify.getCart(function(cart){
            if (response.status) {           
              this.handleErrorMessage(response.description);
              return;
            }           

            // Update cart item counter
            var cartItemCounter = document.getElementById('count_item_cart');
            jQuery.getJSON('/cart.js', function (cart) {
              var newCount = cart.item_count;
              if (newCount != 0) {
                if (cartItemCounter != null) {
                  cartItemCounter.innerHTML = newCount;
                  $('#count_item_cart').show();
                }
              }
            });

            // Update cart contents dynamically without page reload
            // You can trigger a function to refresh the cart modal here
            updateCartModalContents(cart);

          }.bind(this));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Function to update the cart modal contents dynamically
function updateCartModalContents(cart) {
  // Code to update the cart modal based on the new cart data (cart)
  // Update the cart modal DOM elements with the new product data
  console.log('Cart updated:', cart);
}
